.ar{aspect-ratio:1/1;}